import React from 'react';
import cx from 'classnames';

import Spacer from '../spacer/Spacer';

const Loading = props => {
    const { className, ...otherProps } = props; //eslint-disable-line react/prop-types
    return (
        <Spacer
            className={cx('es-loading', className)}
            top={32}
            bottom={32}
            {...otherProps}
        />
    );
};

Loading.displayName = 'Loading';

export default Loading;
